import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "label"
}
const _hoisted_2 = { class: "text" }
const _hoisted_3 = { class: "input-control-row" }
const _hoisted_4 = ["data-cy"]

import { VIconSvg } from "@/components";
import { computed } from "vue";
import { kebabCase } from "lodash";
import { TranslateResult } from "vue-i18n";

interface Props {
  options: Array<{
    label: string | TranslateResult;
    code: string;
  }>;
  label?: string | TranslateResult;
  value?: string | boolean;
  required?: boolean;
  trackBy?: string;
  disabled?: boolean;
  description?: string | TranslateResult;
  allowEmpty?: boolean;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'VInputControl',
  props: {
    options: { default: () => [
    {
      label: "",
      code: "",
    },
  ] },
    label: { default: "" },
    value: { type: [String, Boolean], default: "" },
    required: { type: Boolean, default: false },
    trackBy: { default: "code" },
    disabled: { type: Boolean, default: false },
    description: { default: "" },
    allowEmpty: { type: Boolean, default: false }
  },
  emits: ["input"],
  setup(__props: any, { emit: __emit }) {

const emit = __emit;

const props = __props;

const activeItem = computed({
  get() {
    return props.value;
  },
  set(value) {
    if (props.allowEmpty && activeItem.value === value) {
      value = "";
    }

    emit("input", value);
  },
});

const inputWrapperClasses = computed(() => {
  const classes = {
    "input-control-required": props.required,
    "input-control-disabled": props.disabled,
  };

  return [classes];
});

const isShownInfoIcon = computed(() => {
  return !!props.description;
});

const onClickItem = (value: string) => {
  return () => {
    if (!props.disabled) activeItem.value = value;
  };
};

const getItemClasses = (value: string) => {
  return { active: activeItem.value === value };
};

return (_ctx: any,_cache: any) => {
  const _directive_touch = _resolveDirective("touch")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["input-control", inputWrapperClasses.value])
  }, [
    (_ctx.label.length)
      ? (_openBlock(), _createElementBlock("label", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.label), 1),
          (isShownInfoIcon.value)
            ? (_openBlock(), _createBlock(_unref(VIconSvg), {
                key: 0,
                tooltip: _ctx.description,
                name: "InfoCircle2",
                color: "fc-stroke",
                size: "xs"
              }, null, 8, ["tooltip"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_3, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.options, (item, index) => {
        return _withDirectives((_openBlock(), _createElementBlock("div", {
          key: index,
          class: _normalizeClass(["item", getItemClasses(item[_ctx.trackBy])]),
          "data-cy": `input-control-${_unref(kebabCase)(item.code)}`
        }, [
          _createTextVNode(_toDisplayString(item.label), 1)
        ], 10, _hoisted_4)), [
          [_directive_touch, onClickItem(item[_ctx.trackBy])]
        ])
      }), 128))
    ])
  ], 2))
}
}

})